module.exports = __webpack_public_path__ + "static/media/food-grid.a267c8aa.png";